const deleteTealiumExtraData = ({ keysToDelete = [] }) => {
  try {
    const dl = window?.tealiumDl || {};
    const updated = JSON.parse(JSON.stringify(dl));
    keysToDelete.forEach((key) => delete updated[key]);
    if (Object.keys(dl).length) {
      window.tealiumDl = JSON.parse(JSON.stringify(updated));
    }
  } catch (error) {
    console.log('Error deleting tealium extra data >>:', error);
  }
};

export default deleteTealiumExtraData;
